export default {
  'memberAreaPointsHistory.title': 'กิจกรรมสะสมแต้ม',
  'memberAreaPointsHistory.point_detail': 'รายละเอียดการสะสมแต้ม',
  'memberAreaPointsHistory.event_name': 'ชื่อกิจกรรม',
  'memberAreaPointsHistory.placeholder.event': 'กรุณาระบุชื่อกิจกรรม',
} as Record<string, string>;
